import axios from "axios";
import SignUpData from "@/authSection/types/SignUpData";
import LoginFormData from "@/authSection/types/LoginFormData";

export default {
  createClient(data: SignUpData) {
    return axios.post('/api/sign-up', data)
  },

  checkEmail(email: string) {
    return axios.post('/api/check-email', { email })
  },

  loginClient(loginData: LoginFormData) {
    return axios.post('/api/login', loginData)
  },

  recoveryPassword(data: { email: string }) {
    return axios.post('/api/password/forgot', data)
  },

  async getAuthStatus() {
    return (await axios.get('/api/auth')).data
  },

  async requestEmailVerify() {
    return (await axios.post('/api/verify-email')).data
  },
}